import { NOTIFICATION_INTERVAL_DELAY } from '@/constants/notification';
import Vue from 'vue';
import Router from 'vue-router';
import routes from '@/router/routes';
import store from '@/store/store';
import apiNotifications from '@/api/notifications';

Vue.use(Router);

let isInited = false;

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

function getNotifications() {
  return apiNotifications.get().then(response => {
    store.dispatch('view/setNotifications', response.data.items);
    // メンテナンスモードの場合は強制的にhomeに移動する
    if (store.getters['view/isMaintenance']) {
      router.push({ name: 'home', replace: true });
    }
  });
}

function updateMeta(to) {
  if (to.meta && to.meta.title) {
    document.title = `${to.meta.title} | ${process.env.VUE_APP_SITENAME}`;
  }

  const robots = 'noindex,nofollow';
  document.getElementById('robots').setAttribute('content', robots);
}

function beforeEach(to, from, next) {
  setTimeout(next, 100);
}

router.beforeEach((to, from, next) => {
  // ローダー表示
  // fromもtoもサイドバーがある場合は、main部分のみ表示
  beforeEach(to, from, next);
  if (!isInited) {
    isInited = true;
    // 1分毎に謹告を取得する
    setInterval(getNotifications, NOTIFICATION_INTERVAL_DELAY);
    getNotifications();
  }
});

router.afterEach((to, from) => {
  // タイトルなどを更新
  updateMeta(to);
});

export default router;
